import { render } from "./TransferBtcForm.vue?vue&type=template&id=047cafa6&scoped=true&ts=true"
import script from "./TransferBtcForm.vue?vue&type=script&lang=ts"
export * from "./TransferBtcForm.vue?vue&type=script&lang=ts"

import "./TransferBtcForm.vue?vue&type=style&index=0&id=047cafa6&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047cafa6"]])

export default __exports__